import { ArrowDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden text-sand"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/32915492/pexels-photo-32915492.jpeg"
          alt="Vast rugged Australian Outback dirt road stretching to the horizon"
          className="w-full h-full object-cover animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/55 via-charcoal/30 to-charcoal/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/40 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 min-h-screen flex flex-col">
        <div className="h-20" />

        <div className="flex-1 flex items-center">
          <div className="max-w-4xl">
            <div
              data-testid="hero-overline"
              className="flex items-center gap-4 text-xs md:text-sm uppercase tracking-[0.32em] text-sand/85 mb-8"
            >
              <span className="inline-block w-10 h-px bg-ochre" />
              National Indigenous Food Resilience Infrastructure
            </div>

            <h1
              data-testid="hero-headline"
              className="font-serif font-light text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight"
            >
              Rebuilding local<br />
              <span className="italic font-light text-ochre">food</span> capability<br />
              across remote Australia.
            </h1>

            <p
              data-testid="hero-subline"
              className="mt-10 max-w-2xl text-base md:text-lg leading-relaxed text-sand/85 font-light"
            >
              Growing Country is an Indigenous-led national initiative
              strengthening local food production, community capability and
              regional resilience — where Australia's food system is most
              exposed.
            </p>

            <div className="mt-12 flex flex-wrap items-center gap-4">
              <a
                href="#system"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-3 bg-rust text-sand px-8 py-4 text-xs uppercase tracking-[0.22em] hover:bg-rust-dark transition-colors"
              >
                Explore the system
                <span aria-hidden>→</span>
              </a>
              <a
                href="#get-involved"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-3 border border-sand/60 text-sand px-8 py-4 text-xs uppercase tracking-[0.22em] hover:bg-sand hover:text-charcoal transition-colors"
              >
                Partner with us
              </a>
            </div>
          </div>
        </div>

        <div className="pb-10 md:pb-14">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-10 border-t border-sand/20 pt-8">
            {[
              { stat: "1 in 3", label: "remote households experiencing food insecurity" },
              { stat: "30–60%", label: "higher fresh-food prices in remote stores" },
              { stat: "$0.65", label: "of each food dollar lost to freight & supply" },
              { stat: "120+", label: "remote communities within national scope" },
            ].map((item, i) => (
              <div key={i} data-testid={`hero-stat-${i}`}>
                <div className="font-serif text-3xl md:text-4xl text-sand tick-num">
                  {item.stat}
                </div>
                <div className="mt-2 text-[11px] md:text-xs uppercase tracking-[0.2em] text-sand/65 leading-relaxed">
                  {item.label}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 flex items-center gap-3 text-sand/60 text-[11px] uppercase tracking-[0.3em]">
            <ArrowDown className="w-4 h-4 animate-bounce" strokeWidth={1.5} />
            Scroll to begin
          </div>
        </div>
      </div>
    </section>
  );
}
